<script>
import { isEqual } from 'lodash';
// Vuex
import { mapState } from 'vuex';
import { FETCH_TEAMS } from '@/store/action-types';
import { GET_TEAMS } from '@/store/mutation-types';

export default {

  computed: {
    ...mapState({
      allTeams: state => state[GET_TEAMS.stateKey] || [],
      allTeamsLoading: state => state[GET_TEAMS.loadingKey],
    }),
    /** Array: Teams managed by the current team */
    utilsManagedTeams() {
      if (!this.currentTeam) {
        return [];
      }
      const team = this.allTeams.find(t => t.id === this.currentTeam.id);
      if (team && team.users && team.users.length) {
        const userIds = team.users.map(user => user.id);
        return this.allTeams.filter(t => t.accesses.some(userId => userIds.includes(userId)));
      }
      return [];
    },
    /** Array: Array of ids to override from components */
    utilsSelectedTeamIdsToFilter() {
      return null;
    },
    /** Array: Ids of all the teams */
    utilsAllTeamIds() {
      return this.allTeams.map(t => t.id);
    },
    utilsSelectedTeamIds() {
      if (this.utilsSelectedTeamIdsToFilter === null) {
        return this.utilsManagedTeams.map(t => t.id);
      }
      const teamProp = this.utilsSelectedTeamIdsToFilter.map(t => Number(t));
      return teamProp.filter(id => this.utilsAllTeamIds.includes(id));
    },
  },

  created() {
    if (!this.allTeamsLoading) {
      this.$store.dispatch(FETCH_TEAMS);
    }
  },

};
</script>
